export default {
	people: {
		title: "Gestão Pessoas",
	},
	spiritualManagement: {
		title: "Gestão Espiritual",
	},
	ritualManagement: {
		title: "Gestão Rituais",
	},
	templeManagement: {
		title: "Gestão Templo",
	},
	tools: {
		title: "Ferramentas",
	},
};
